import {
    Container,
    Ellipsis,
    FormInput,
    FormLabel,
    FormNumber,
    FormTextarea,
    Grid,
    Icon,
    Island,
    IslandAlt,
    Menu,
    MenuItem,
    Modal,
    ModalBody,
    ModalHeader,
    NoResults,
    Spacer,
    Tab,
    Table,
    Tabs,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useModal,
} from "@holta/ui";
import { MenuList } from "react-select/src/components/Menu";
import styled from "styled-components";
import { useMergedEditOrder } from "../hooks/useMergedEditOrder";
import { libTypes } from "@holta/lib";
import { InputProductSelect } from "../../../components/InputProductSelect";
import editOrderActions from "../../../actions/editOrder";
import { InputHandingSelect } from "../../../components/InputHandingSelect";
import { useTabs } from "../../../hooks/useTabs";
import React from "react";
import FocusLock from "react-focus-lock";
import { ModalDuplicateLinkedDoors } from "./ModalDuplicateLinkedDoors";

interface Props {
    orderItem: libTypes.EditedCarcaseOrderItem;
}

export const OrderItemsEditCarcaseRow = ({ orderItem }: Props) => {
    const editOrder = useMergedEditOrder();
    const firstInputRef = React.useRef<HTMLInputElement>(null);
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [duplicateDoors, setDuplicateDoors] = React.useState<libTypes.LinkedDoorOrderItem[][]>([]);
    const multipleDoorsCB = React.useRef<(doors : libTypes.LinkedDoorOrderItem[]) => void>();
    const { openModal } = useModal();
    const tabs = useTabs("basic");

    React.useEffect(() => {
        firstInputRef.current?.focus();
    }, [orderItem.id]);

    React.useEffect(() => {
        setTimeout(() => {
            if (!containerRef.current) return;
            if(containerRef.current.getBoundingClientRect().bottom < (window.innerHeight - 80)) return;
            containerRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }, 300);
    }, [orderItem.code]);

    const wrappedSaveAndAddAnother = () => {
        editOrderActions.saveAndAddNewCarcaseItem(() => {});
        tabs.setCurrent("basic");
        firstInputRef.current?.focus();
    };

    if (!editOrder) return null;
    return (
        <>
        <Tr ref={containerRef} style={{ scrollMarginBottom: "60px" }}>
            <div
                style={{
                    width: "calc(100% + 16px)",
                    backgroundColor: "white",
                    margin: "-1px -8px",
                }}
            >
                <EditingRow>
                    <FocusLock>
                        <Grid.Row>
                            <Spacer xs={[0, 2]}>
                                <Tabs height={6}>
                                    <Tab
                                        height={6}
                                        isSelected={tabs.current === "basic"}
                                        onClick={() => tabs.setCurrent("basic")}
                                        inline
                                    >
                                        Basic
                                    </Tab>
                                    <Tab
                                        height={6}
                                        isSelected={tabs.current === "advanced"}
                                        inline
                                        onClick={() => tabs.setCurrent("advanced")}
                                    >
                                        Advanced
                                    </Tab>
                                </Tabs>
                            </Spacer>
                        </Grid.Row>
                        <hr />
                        {tabs.current === "basic" && (
                            <Grid.Row>
                                <Grid.Col xs={{ cols: 6 }}>
                                    <Spacer xs={[2, 1, 2, 2]}>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Item Code
                                                    </FormLabel>
                                                </Grid.Col>
                                                <Grid.Col xs={{ cols: 8 }}>
                                                    <InputProductSelect
                                                        value={{
                                                            code: orderItem.code,
                                                            productId: orderItem.productId,
                                                        }}
                                                        ref={firstInputRef}
                                                        onChange={(option: { value: string }) =>
                                                            editOrderActions.setCarcaseItemCode(
                                                                option.value
                                                            )
                                                        }
                                                    />
                                                </Grid.Col>
                                            </Grid.Row>
                                        </Spacer>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Quantity
                                                    </FormLabel>
                                                </Grid.Col>
                                                <Grid.Col xs={{ cols: 8 }}>
                                                    <FormNumber
                                                        onBlur={(e) =>
                                                            editOrderActions.setCarcaseItemQuantity(
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        disabled={!orderItem.code}
                                                        isFloat
                                                        placeholder=""
                                                        value={orderItem.quantity}
                                                        style={{ width: "100%" }}
                                                    />
                                                </Grid.Col>
                                            </Grid.Row>
                                        </Spacer>
                                        <Grid.Row>
                                            <Spacer xs={[0.25, 0]}>
                                                <Grid.Row>
                                                    <Grid.Col xs={{ cols: 4 }}>
                                                        <FormLabel type="contained" position="left">
                                                            H
                                                        </FormLabel>
                                                    </Grid.Col>
                                                    <Grid.Col xs={{ cols: 8 }}>
                                                        <FormNumber
                                                            onChange={(e) =>
                                                                editOrderActions.setCarcaseItemHeight(
                                                                    Number(e.target.value)
                                                                )
                                                            }
                                                            disabled={!orderItem.code}
                                                            isFloat
                                                            placeholder=""
                                                            value={
                                                                orderItem.hEdited
                                                                    ? orderItem.hEdited
                                                                    : orderItem.h || ""
                                                            }
                                                            style={{ width: "100%" }}
                                                        />
                                                    </Grid.Col>
                                                </Grid.Row>
                                            </Spacer>

                                            <Spacer xs={[0.25, 0]}>
                                                <Grid.Row>
                                                    <Grid.Col xs={{ cols: 4 }}>
                                                        <FormLabel type="contained" position="left">
                                                            W
                                                        </FormLabel>
                                                    </Grid.Col>
                                                    <Grid.Col xs={{ cols: 8 }}>
                                                        <FormNumber
                                                            onChange={(e) =>
                                                                editOrderActions.setCarcaseItemWidth(
                                                                    Number(e.target.value)
                                                                )
                                                            }
                                                            disabled={!orderItem.code}
                                                            isFloat
                                                            placeholder=""
                                                            value={
                                                                orderItem.wEdited
                                                                    ? orderItem.wEdited
                                                                    : orderItem.w || ""
                                                            }
                                                            style={{ width: "100%" }}
                                                        />
                                                    </Grid.Col>
                                                </Grid.Row>
                                            </Spacer>
                                            <Spacer xs={[0.25, 0]}>
                                                <Grid.Row>
                                                    <Grid.Col xs={{ cols: 4 }}>
                                                        <FormLabel type="contained" position="left">
                                                            D
                                                        </FormLabel>
                                                    </Grid.Col>
                                                    <Grid.Col xs={{ cols: 8 }}>
                                                        <FormNumber
                                                            onChange={(e) =>
                                                                editOrderActions.setCarcaseItemDepth(
                                                                    Number(e.target.value)
                                                                )
                                                            }
                                                            disabled={!orderItem.code}
                                                            isFloat
                                                            placeholder=""
                                                            value={
                                                                orderItem.dEdited
                                                                    ? orderItem.dEdited
                                                                    : orderItem.d || ""
                                                            }
                                                            style={{ width: "100%" }}
                                                        />
                                                    </Grid.Col>
                                                </Grid.Row>
                                            </Spacer>
                                        </Grid.Row>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Handing
                                                    </FormLabel>
                                                </Grid.Col>
                                                <Grid.Col xs={{ cols: 8 }}>
                                                    <InputHandingSelect
                                                        isDisabled={!orderItem.code}
                                                        value={orderItem.handing}
                                                        onChange={(option: {
                                                            value: libTypes.Handing;
                                                        }) =>
                                                            editOrderActions.setCarcaseItemHanding(
                                                                option.value
                                                            )
                                                        }
                                                    />
                                                </Grid.Col>
                                            </Grid.Row>
                                        </Spacer>
                                    </Spacer>
                                </Grid.Col>
                                <Grid.Col xs={{ cols: 6 }}>
                                    <Spacer xs={[2, 2, 2, 1]}>
                                        <Spacer xs={[0.25, 0]}>
                                            <FormLabel type="contained">Description</FormLabel>
                                            <FormTextarea
                                                style={{ width: "100%" }}
                                                disabled={!orderItem.code}
                                                value={orderItem.description}
                                                onChange={(e) =>
                                                    editOrderActions.setCarcaseItemDescription(
                                                        e.target.value
                                                    )
                                                }
                                            ></FormTextarea>
                                        </Spacer>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Specification
                                                    </FormLabel>
                                                </Grid.Col>
                                                <Grid.Col xs={{ cols: 8 }}>
                                                    <FormInput
                                                        disabled
                                                        value={orderItem.specification}
                                                        style={{ width: "100%" }}
                                                    />
                                                </Grid.Col>
                                            </Grid.Row>
                                        </Spacer>
                                        <Spacer xs={[0.25, 0]}>
                                            <FormLabel type="contained">Notes</FormLabel>
                                            <FormTextarea
                                                style={{ width: "100%" }}
                                                disabled={!orderItem.code}
                                                value={orderItem.notes}
                                                onChange={(e) =>
                                                    editOrderActions.setCarcaseItemNotes(
                                                        e.target.value
                                                    )
                                                }
                                            ></FormTextarea>
                                        </Spacer>
                                    </Spacer>
                                </Grid.Col>
                            </Grid.Row>
                        )}

                        {tabs.current === "advanced" && (
                            <Grid.Row>
                                <Grid.Col xs={{ cols: 6 }}>
                                    <Spacer xs={[2, 1, 2, 2]}>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Price
                                                    </FormLabel>
                                                </Grid.Col>

                                                <FormNumber
                                                    onBlur={(e) =>
                                                        editOrderActions.setCarcaseItemPrice(
                                                            Number(e.target.value)
                                                        )
                                                    }
                                                    allowNegative
                                                    disabled={!orderItem.code}
                                                    isFloat
                                                    placeholder=""
                                                    value={orderItem.price}
                                                    style={{ width: "100%" }}
                                                />
                                            </Grid.Row>
                                        </Spacer>
                                    </Spacer>
                                </Grid.Col>
                                <Grid.Col xs={{ cols: 6 }}>
                                    <Spacer xs={[2, 2, 2, 1]}>
                                        <Spacer xs={[0.25, 0]}>
                                            <Grid.Row>
                                                <Grid.Col xs={{ cols: 4 }}>
                                                    <FormLabel type="contained" position="left">
                                                        Discount
                                                    </FormLabel>
                                                </Grid.Col>
                                                <FormNumber
                                                    onBlur={(e) =>
                                                        editOrderActions.setCarcaseItemDiscount(
                                                            Number(e.target.value)
                                                        )
                                                    }
                                                    disabled={!orderItem.code}
                                                    isFloat
                                                    placeholder=""
                                                    value={orderItem.discount}
                                                    style={{ width: "100%" }}
                                                />
                                            </Grid.Row>
                                        </Spacer>
                                    </Spacer>
                                </Grid.Col>
                            </Grid.Row>
                        )}

                        <Spacer xs={[2]}>
                            <Grid.Row xs={{ justify: "end" }}>
                                <button onClick={editOrderActions.clearEditOrderItem} tabIndex={-1}>
                                    Cancel
                                </button>
                                <Spacer xs={[0.25]}></Spacer>
                                <button
                                    disabled={!orderItem.code}
                                    onClick={() => editOrderActions.saveEditOrderItem((duplicates, cb) => {
                                        setDuplicateDoors(duplicates);
                                        multipleDoorsCB.current = cb;
                                        openModal("MODAL_DUPLICATE_LINKED_DOORS");
                                    })}
                                    tabIndex={-1}
                                >
                                    Save
                                </button>
                                <Spacer xs={[0.25]}></Spacer>
                                <button
                                    className={orderItem.code && "primary"}
                                    disabled={!orderItem.code}
                                    onClick={wrappedSaveAndAddAnother}
                                >
                                    Save & add another
                                </button>
                            </Grid.Row>
                        </Spacer>
                        
                    </FocusLock>
                </EditingRow>
            </div>
        </Tr>
        <ModalDuplicateLinkedDoors duplicateDoors={duplicateDoors} handleConfirm={multipleDoorsCB.current! }/>
        </>
    );
};

const EditingRow = styled.div`
    border: 1px solid ${(props) => props.theme.color.highlight};
    border-radius: 4px;
    box-shadow: 0px 4px 15px 5px #cccbcb;
`;
